import { render, staticRenderFns } from "./BadgeFormView.vue?vue&type=template&id=51f03656&scoped=true&"
import script from "./BadgeFormView.vue?vue&type=script&lang=js&"
export * from "./BadgeFormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f03656",
  null
  
)

export default component.exports